export const BOOKING_LIFECYCLE_GUIDANCE = 'A confirmed assignment must use the original business booking lifecycle to cancel, record a practitioner withdrawal, relist, reschedule or replace it. Admin listing/application/bid controls cannot perform these actions. Review retained booking history; ambiguous legacy assignments need investigation.';

export function lifecycleError(error, fallback) {
  if (error?.response?.status !== 409) return error?.response?.data?.message || fallback;
  const message = error.response.data?.message;
  const code = error.response.data?.data?.code;
  return [message, code ? `Reference: ${code}.` : '', BOOKING_LIFECYCLE_GUIDANCE].filter(Boolean).join(' ');
}
